
export const c = {
	PL_STATUS_INITIAL: 0,
	PL_STATUS_FC_REPORTED: 1,
	PL_STATUS_GM_APPROVED: 6,
	PL_STATUS_HO_APPROVED: 8,
	PL_STATUS_FINAL: 10,
	PL_STATUS_OUTDATED: 11,

	PL_SCENARIO_FACT: 1,
	PL_SCENARIO_BUD: 0,
	PL_SCENARIO_FCST: 2,

	PL_TYPE_ACC: 1,
	PL_TYPE_RES: 2,
	PL_TYPE_ADD: 3,
	PL_TYPE_COR: 4,
	PL_TYPE_HOD: 5,
	PL_TYPE_SYS: 6,
	PL_TYPE_FCT: 7,

	PR_LIMIT_1: 5000,
	PR_LIMIT_2: 40000,
	PR_LIMIT_3: 500000,
	PR_LIMIT_4: 100000,	// лимит суммы для согласования SBCU Counselor

	VAT: 20,
	PERSONAL_TAX: 13,
	PAYROLL_TAX: 30.2,

}
